export default __webpack_public_path__ + "static/header_banner-990d6a73782854f4e520c0ee3119b1cc.png";